module.exports = __webpack_public_path__ + "static/media/8.8473e1f4.JPG";